export const RECEIVE_CATEGORIES = 'RECEIVE_CATEGORIES'
export const RECEIVE_CATEGORY = 'RECEIVE_CATEGORY'
export const RECEIVE_CATEGORIES_ERROR = 'RECEIVE_CATEGORIES_ERROR'
export const CLEAR_CATEGORIES = 'CLEAR_CATEGORIES'
export const DELETE_RELATED_CATEGORY_CONTENT = 'DELETE_RELATED_CATEGORY_CONTENT'
export const RECEIVE_RELATED_CATEGORY_CONTENT = 'RECEIVE_RELATED_CATEGORY_CONTENT'
